<template>
  <button
    type="button"
    class="mt-4 w-full rounded-md border border-dotted border-pink-500 bg-pink-25 p-2 px-3 text-center text-sm text-pink-500"
    @click="showCouponModal = true"
  >
    <span class="mb-3 mt-1 text-sm font-medium text-pink-600">
      <strong v-text="heading" class="text-pink-700 font-bold" />
      <span class="ml-1">&nbsp;Save {{ couponValue }}!</span>
    </span>
    <span class="my-1 flex items-center justify-center gap-2 rounded-[3px] bg-pink-500 p-2 font-bold text-white transition-colors duration-300 hover:bg-pink-600">
      <span>Get the code</span>
      <SvgIcon
        aria-hidden="true"
        icon-name="arrow"
        class="h-4 w-3.5 shrink-0"
      />
    </span>
  </button>

  <TransitionRoot
    as="template"
    :show="showCouponModal"
  >
    <Dialog
      class="relative z-50"
      :open="showCouponModal"
      @close="showCouponModal = false"
    >
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div
          aria-hidden="true"
          class="fixed inset-0 bg-[rgba(0,0,0,0.5)]"
        />
      </TransitionChild>

      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0 scale-95"
        enter-to="opacity-100 scale-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100 scale-100"
        leave-to="opacity-0 scale-95"
      >
        <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel class="relative overflow-hidden rounded-lg bg-white p-6 text-left shadow-sm transition-all sm:my-8 sm:w-full sm:max-w-lg">
              <button
                type="button"
                class="absolute right-4 top-4 text-gray-400 hover:text-gray-500 focus:outline-hidden focus:ring-2 focus:ring-pink-500 focus:ring-offset-2"
                @click="showCouponModal = false"
              >
                <span class="sr-only">Close</span>
                <SvgIcon
                  aria-hidden="true"
                  icon-name="x"
                  class="h-5 w-5"
                />
              </button>
              
              <div class="prose prose-h3:text-pink-500 prose-h3:font-bold "> 
                <slot> </slot>
              </div>
              
      
              <div class="flex items-center gap-2 cursor-pointer">
                <input
                  id="accepted"
                  v-model="accepted"
                  type="checkbox"
                  name="accepted"
                  class="h-4 w-4 rounded border-gray-300 text-pink-500 focus:ring-pink-500"
                >
                <label for="accepted" class="pt-1 text-base">Yes, I meet the above criteria.</label>
              </div>
              
              <div  v-if="accepted">
              <div
               
                class="flex w-full rounded-lg border border-gray-300 shadow-xs mt-2"
              >
                <div class="w-full overflow-hidden rounded-l-lg bg-gray-50 px-3.5 py-2.5">
                  <span
                    class="text-gray-500"
                    v-text="coupon"
                  />
                </div>
                <button
                  class="flex shrink-0 items-center gap-2 rounded-r-lg border-l border-l-gray-300 px-6 py-2.5 font-semibold text-gray-700 transition-colors hover:bg-pink-500 hover:text-white focus-visible:-ring-offset-2"
                  type="button"
                  @click="handleCopy"
                >
                  <SvgIcon
                    aria-hidden="true"
                    :icon-name="hasCopied ? 'check' : 'copy'"
                    class="size-5 shrink-0"
                  />
                  <span v-text="hasCopied ? 'Copied!' : 'Copy'" />
                  <span
                    class="sr-only"
                    v-text="'coupon code'"
                  />
                </button>

              </div>
              <div class="mt-2 prose prose-sm prose-p:text-gray-500 prose-p:italic">
                <p>Garbanzo reserves the right to review requests and revoke access if eligibility criteria are not met.</p>
              </div>

            </div>
            </DialogPanel>
          </div>
        </div>
      </TransitionChild>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useClipboard } from '@vueuse/core'
import { Dialog, DialogPanel, TransitionRoot, TransitionChild } from '@headlessui/vue'
import SvgIcon from '~/components/global/SvgIcon.vue'

defineOptions({
  name: 'CouponModal',
})

const props = defineProps<{
  heading: string;
  coupon: string
  couponValue: string
}>()

const { copy } = useClipboard({ source: props.couponValue })
const hasCopied = ref(false)

const handleCopy = async () => {
  await copy(props.coupon)
  hasCopied.value = true
  setTimeout(() => {
    hasCopied.value = false
  }, 2000)
}

const showCouponModal = ref(false)
const accepted = ref(false)
</script>
